import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  envelope: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'envelope' }),
}

export { paths }
